import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import createVuexAlong from 'vuex-along';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins: [
    createVuexAlong({
      name: 'fe-check',
      justSession: true,
      session: {
        list: [...Object.keys(state)]
      }
    })
  ]
});
